import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Lifter } from "types";
import get from "lodash/get";
import { useDisplaySettings } from "./DisplaySettingsProvider";

const LifterName = ({
  currentLifter,
  id,
}: {
  currentLifter: Lifter | undefined | null;
  id: string;
}) => {
  const { editMode } = useDisplaySettings();

  return (
    <DisplayComponent style={{ top: 0, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 38,
          width: sizeMultiplier * 600,
        };

        let lifterName = get(currentLifter, "name", "AAAAAAA AAAAAAA");

        if (editMode) {
          lifterName = "Test Lifter";
        }

        return (
          <div style={style} className="lifter-details">
            {lifterName}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default LifterName;
